import { render, staticRenderFns } from "./ExpressNews.vue?vue&type=template&id=79826674&"
import script from "./ExpressNews.vue?vue&type=script&lang=js&"
export * from "./ExpressNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports